//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadVideo from "./videos.vue"
import { uploadImg } from "@/api/uploadImg";
import Sortable from 'sortablejs';
import richText from "./RichText";
import treeComp from './tree';

export default {
    components: { uploadVideo, richText, treeComp },
    props: [],
    data() {
        var vallidImage = (rule, value, callback, source) => {
            console.log(this.arrS.length);
            if (this.arrS.length == 0) {
                callback(new Error("商品图片不能为空"));
            } else {
                callback();
            }
        };
        var jiagesa = (rule, value, callback, source) => {
            console.log(this.arrS.length);
            if (!this.jiage) {
                callback(new Error("价格不能为空"));
            } else {
                callback();
            }
        };
        return {


            // 上传视频

            videoList: [],
            fileVideoList: [],
            videoLimit: 1,


            //表单部分 

            form: {
                supplier: "",//所属供应商
                brand: "",//商品品牌
                goodsType: "",//商品分类
                goodsName: "",//商品名称
                goodsPoints: "",//商品卖点
                goodsImage: [],//商品图片
                goodsVideo: "",//主图视频
            },
            premisesFileList: [], //商品图片
            previewImgUrl: "", //预览图片url
            previeImgVisible: false, //预览图片弹框
            editValue: '', //富文本
            // 表单校验

            rules: {
                supplier: [{
                    required: true,
                    message: "所属供应商不能为空",
                    trigger: "change",
                }],
                brand: {
                    required: true,
                    message: "商品品牌不能为空",
                    trigger: "change",
                },
                classA: {
                    required: true,
                    message: "商品分类不能为空",
                    trigger: "change",
                },
                goodsName: {
                    required: true,
                    message: "商品名称不能为空",
                    trigger: "blur",
                },
                goodsImage: [{
                    required: true,
                    message: "商品图片不能为空",
                    validator: vallidImage,
                    trigger: "change",

                }],
                jiage: {
                    required: true,
                    message: "价格不能为空",
                    validator: jiagesa,
                    trigger: "change",
                },

            },

            //规则与价格

            SpecificationImage: [], //上传规格图片
            orderListsImg: [],
            videosImg: '',
            specList: [],//规格[{"id":0,"title":"尺寸","value":[{"id":0,"content":""},{}]}]
            specListHead: [],//规格-页面上显示的表头
            skuList: {
                children: [],
            },
            videos: '',
            treeCompKey: 0,

            checked: true,
            jiage: "",
            hjx: "",
            ghfs: 10,
            ghzq: "",
            // tabs 

            flag: 0,
            ppList: [],
            flList: [],

            input: "",
            tableData: [

            ],
            options: [],
            arrS: [],
            // arrSS: [],
            //规格
            specListHead: [],
            specList: [],
            formSku: {
                title: "",
                checkedCategory: [],
                image: [],
                status: "10",
                ordering: 0,
                content: "",
            },

            treeCompKey: 0,
            editIniting: false,

            specJson: [],
            specTitleValueJson: [],
            arrS2: [],
            listsData: []
        };
    },
    mounted() {
        this.initDragSort();
        // var spec_detail = [
        //     {
        //         "id": "191",
        //         "product_id": "5",
        //         "spec_title_id": "20",
        //         "spec_title_name": "重量",
        //         "spec_value_id": "577",
        //         "spec_value_name": "2.5KG",
        //         "level": "1",
        //         "children": [
        //             {
        //                 "id": "192",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "579",
        //                 "spec_value_name": "礼盒装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "193",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "66.00",
        //                         "price_underline": "66.30",
        //                         "stock": "666"
        //                     },
        //                     {
        //                         "id": "194",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "77.00",
        //                         "price_underline": "77.30",
        //                         "stock": "77"
        //                     },
        //                     {
        //                         "id": "195",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "192",
        //                         "price": "88.00",
        //                         "price_underline": "88.30",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "191"
        //             },
        //             {
        //                 "id": "196",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "580",
        //                 "spec_value_name": "袋装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "197",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "198",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "199",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "196",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "191"
        //             }
        //         ],
        //         "parent_id": "0"
        //     },
        //     {
        //         "id": "200",
        //         "product_id": "5",
        //         "spec_title_id": "20",
        //         "spec_title_name": "重量",
        //         "spec_value_id": "578",
        //         "spec_value_name": "5KG",
        //         "level": "1",
        //         "children": [
        //             {
        //                 "id": "201",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "579",
        //                 "spec_value_name": "礼盒装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "202",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "203",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "204",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "201",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "200"
        //             },
        //             {
        //                 "id": "205",
        //                 "product_id": "5",
        //                 "spec_title_id": "21",
        //                 "spec_title_name": "包装",
        //                 "spec_value_id": "580",
        //                 "spec_value_name": "袋装",
        //                 "level": "2",
        //                 "children": [
        //                     {
        //                         "id": "206",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "581",
        //                         "spec_value_name": "6666",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "207",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "582",
        //                         "spec_value_name": "7777",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     },
        //                     {
        //                         "id": "208",
        //                         "product_id": "5",
        //                         "spec_title_id": "78",
        //                         "spec_title_name": "5555",
        //                         "spec_value_id": "583",
        //                         "spec_value_name": "8888",
        //                         "level": "3",
        //                         "parent_id": "205",
        //                         "price": "0.00",
        //                         "price_underline": "0.00",
        //                         "stock": "0"
        //                     }
        //                 ],
        //                 "parent_id": "200"
        //             }
        //         ],
        //         "parent_id": "0"
        //     }
        // ]
        // var spec = [
        //     {
        //         "id": "20",
        //         "title": "重量",
        //         "value": [
        //             {
        //                 "id": "577",
        //                 "spec_title_id": "20",
        //                 "content": "2.5KG"
        //             },
        //             {
        //                 "id": "578",
        //                 "spec_title_id": "20",
        //                 "content": "5KG"
        //             }
        //         ]
        //     },
        //     {
        //         "id": "21",
        //         "title": "包装",
        //         "value": [
        //             {
        //                 "id": "579",
        //                 "spec_title_id": "21",
        //                 "content": "礼盒装"
        //             },
        //             {
        //                 "id": "580",
        //                 "spec_title_id": "21",
        //                 "content": "袋装"
        //             }
        //         ]
        //     },
        //     {
        //         "id": "78",
        //         "title": "5555",
        //         "value": [
        //             {
        //                 "id": "581",
        //                 "spec_title_id": "78",
        //                 "content": "6666"
        //             },
        //             {
        //                 "id": "582",
        //                 "spec_title_id": "78",
        //                 "content": "7777"
        //             },
        //             {
        //                 "id": "583",
        //                 "spec_title_id": "78",
        //                 "content": "8888"
        //             }
        //         ]
        //     }
        // ]
        // var resList = [{
        //     skuNames: '白色,100',
        //     productsPrice: 12
        // }, {
        //     skuNames: '白色,200',
        //     productsPrice: 13
        // }]
        var spec_detail = []
        var spec = []
        var resList = []
        this.skuList = { children: spec_detail };
        this.specList = spec;
        console.log("this.skuList", this.skuList)
        this.$router.afterEach((to, form, next) => {
            window.scrollTo(0, 0)
        })
    },
    computed: {
        specListWatch() {
            return JSON.parse(JSON.stringify(this.specList))
        },
    },
    watch: {
        specListWatch: {
            deep: true,
            handler(newVal, oldVal) {
                console.log(newVal);
                this.treeCompKey += 1;
                let newSpecNames = newVal.filter(item => {
                    if (item.title != '' && item.value.length > 0) {
                        if ((item.value.filter(itm => itm.content != '')).length > 0) {
                            return item;
                        }
                    }
                });
                console.log(newSpecNames);

                let oldSpecNames = oldVal.filter(item => {
                    if (item.title != '' && item.value.length > 0) {
                        if ((item.value.filter(itm => itm.content != '')).length > 0) {
                            return item;
                        }
                    }
                });
                console.log(oldSpecNames);

                //过滤掉空的规格值
                let specListHead = [];
                newSpecNames.forEach(item => {
                    let itemNew = { ...item };
                    itemNew.value = item.value.filter(itm => itm.content != '');
                    specListHead.push(itemNew)
                });
                this.specListHead = specListHead;
                if (this.editIniting) {
                    this.editIniting = false;
                    return false;
                }
                if (newSpecNames.length != oldSpecNames.length) {
                    //结构改变-重新排序
                    this.handleSpecDatas1();
                    this.skuOrdering = true;
                } else {
                    //追加/修改规格值-不重新排序
                    this.skuOrdering = false;

                }

            },

        },
        skuList: {
            deep: true,
            handler(newVal, oldVal) {
                console.log(newVal)
            }
        }
    },

    created() {
        this.pinpai()
        this.spflFn()
        this.get_SupplierList()
    },
    methods: {
        // 获取产品详情-修改操作时
        uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
        },

        radioChe(e) {
            console.log(e);
            // if(e==20) 
            this.ghzq = null
        },
        //提交
        submitForm(val) {
            console.log(this.SpecificationImage)
            var imgList = [];
            if (this.SpecificationImage.length > 0) {
                var item = this.SpecificationImage;
                for (var i = 0; i < item.length; i++) {
                    imgList.push(item[i].url)
                }
            }
            console.log(imgList);
            var specJson = [];
            var specTitleValueJson = [];
            var item = this.skuList.children;

            var arr = [];
            var arr2 = [];
            var arr3 = [];
            for (var i = 0; i < item.length; i++) { //循环第一级

                var item2 = item[i].children;
                //第一个数组
                arr.push({
                    valueName: item[i].spec_value_name,
                    valueSort: i,
                    titleImageUrl: imgList.length > 0 ? imgList[i] : ''
                })
                if (item2) {
                    for (var j = 0; j < item2.length; j++) { //循环二级				
                        var item3 = item2[j].children;
                        //第二个数组
                        if (i == 0) {
                            arr2.push({
                                valueName: item2[j].spec_value_name,
                                valueSort: j,
                            });
                        }
                        if (item3) {
                            for (var m = 0; m < item3.length; m++) { //循环三级	
                                //第三个数组
                                console.log(item3[m])
                                if (j == 0 && i == 0) {
                                    arr3.push({
                                        valueName: item3[m].spec_value_name,
                                        valueSort: m,
                                    })
                                }
                                specJson.push({

                                    valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name + ',' + item3[m].spec_value_name,
                                    price: item3[m].price,
                                    valueSort: i
                                })
                            }
                        }
                        if (!item3) {
                            specJson.push({
                                valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name,
                                price: item2[j].price,
                                valueSort: i

                            })
                        }

                    }

                }
                if (!item2) {
                    specJson.push({
                        valueName: item[i].spec_value_name,
                        price: item[i].price,
                        valueSort: i

                    })
                }
            }
            for (let i = 0; i < this.specListHead.length; i++) {
                if (i == 0) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr,
                        titleImageUrl: ''
                    })
                } else if (i == 1) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr2
                    })
                } else if (i == 2) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr3
                    })
                }
            }

            console.log("specTitleValueJson", specTitleValueJson)
            console.log("specJson", JSON.stringify(specJson))
            console.log(this.videos)
            const formName = ['form0', 'form1', 'form2', 'form3']
            const validates = (item) => {
                return new Promise((resolve, reject) => {
                    console.log(this.$refs[item]);
                    if (!this.$refs[item]) {
                        resolve()
                        return false
                    }
                    this.$refs[item].validate((valid) => {
                        if (valid) {
                            resolve()
                        } else {
                            reject(new Error('验证不对'))
                        }
                    })
                })
            }
            let nums = val
            console.log(this.arrS);

            Promise.all(formName.map(item => validates(item))).then(() => {
                console.log(this.tableData);
                console.log(this.videosImg);
                let obj = {
                    brandId: this.form.brand,//品牌id	
                    enterpriseId: this.form.supplier,//供应商id		
                    mainSpuImageUrl: this.arrS[0],//商品主图		
                    // mainSpuVideoUrl: 'http.ceshi.mp4',//商品视频	
                    mainSpuVideoUrl: this.videos,//商品视频	
                    // markingPrice: this.hjx,//划线价		
                    modeOfDay: this.ghzq,//供货周期	
                    modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                    oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                    ordinarySpuImageUrl: this.arrS + '',//商品普通图	
                    parmJson: JSON.stringify(this.tableData),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                    productDesc: this.editValue,//商品描述PC		
                    //  productDescApp: "<p>111</p>",//商品描述App		
                    productsName: this.form.goodsName,//spuName
                    productsPrice: this.jiage,//商品价格	
                    salePoint: this.form.goodsPoints,//卖点
                    specTitleValueJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                    specJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                    status: nums,//状态（10:上架;20:下架)	
                    threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                    twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	
                    mainSpuVideoCoverUrl: this.videosImg
                }
                this.$http.orders.addOrder(obj).then(res => {
                    console.log(res)
                    if (res.status) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$router.push({ path: './list' })

                    }
                })
            }).catch(() => {
                console.log('失败')
            })
        },
        // 供应商获取

        get_SupplierList() {
            let obj = {
                pageNum: 1,
                pageSize: 999
            }
            this.$http.supplierApi.getSupplierList(obj).then(res => {
                // this.options = res.data.szEnterpriseInfoList
                console.log(res);
                this.options = []
                res.data.szEnterpriseInfoList.forEach(item => {
                    this.options.push({ name: item.enterpriseName, id: item.id })
                })
            })
        },
        handleSpecDatas1() {
            let arr = [];
            this.specListHead.forEach(item => {
                if (item.value.length > 0) {
                    let specItemValue = [];
                    item.value.forEach(itm => {
                        if (itm.content) {
                            let obj = {
                                id: itm.id,
                                spec_value_name: itm.content,
                                idx1: itm.idx1,
                                idx2: itm.idx2,
                                spec_title_id: itm.spec_title_id ? itm.spec_title_id : null
                            }
                            specItemValue.push(obj)
                        }
                    })
                    arr.push(specItemValue)
                }
            })
            console.log(arr)
            let arr1 = arr.length > 0 ? [...arr[0]] : [];
            arr1.forEach(item => {
                let idx = 1;
                item = this.handleSpec2(idx, item, arr)
            })
            this.skuList = { children: arr1 };
            console.log('', this.skuList);
        },
        // 添加规格
        addSpecItem() {
            if (this.specList.length > 2) {
                this.$message({
                    message: '最多可添加3条！',
                    type: 'warning'
                });
            } else {
                let idx1 = `${this.specList.length}`;
                let obj = { id: '0', title: "", idx1, value: [] };
                this.specList.push(obj);
            }

            console.log(" this.specList", this.specList)
        },
        // 删除规格
        deleteSpecItem(index) {
            this.specList.splice(index, 1);
        },
        // 添加规格值
        addSpecItemVal(index) {
            let obj = {};
            let specListItem = this.specList[index];
            let idx1 = index, idx2 = specListItem.value.length > 0 ? (specListItem.value[specListItem.value.length - 1].idx2 + 1) : 0;
            if (specListItem.id && specListItem.id != '0') {//对应的父级规格名有id（修改页面）
                obj = { id: '0', idx1, idx2, spec_title_id: specListItem.id, content: '' };
            } else {
                obj = { id: '0', idx1, idx2, content: '' };
            }
            if (this.specList[index].value.length == 5) {
                this.$message({
                    message: '规格值最多5条',
                    type: 'warning'
                });
            } else {
                // this.specList[index].value.push(obj);
                let num = 0
                var arr = [];
                if (this.specList[index].value.length != 0) {
                    if (specListItem.value[specListItem.value.length - 1].content == '') {
                        this.$message.warning('规格值不能为空')
                    } else {
                        this.specList[index].value.push(obj);
                    }
                } else {
                    this.specList[index].value.push(obj);

                }

            }
        },
        //删除规格值
        specItemValDel(index1, index2) {
            let item = this.specList[index1].value[index2];
            item.isDel = true;
            this.handleSpecValues(this.skuList.children, item);
            this.specList[index1].value.splice(index2, 1);
        },
        // 规格名改变-输入事件
        specItemChange(item) {
            if (item.value && item.value.length > 0) {
                item.value = [];
            }
        },
        bl(itm, val, val2) {
            console.log(val)
            let sss = []
            if (this.specList[val].value.length > 1) {
                this.specList[val].value.filter((item, index) => {
                    if (index != val2) {
                        sss.push(item)
                    }
                })
            }
            console.log(sss);
            sss.forEach((item, index) => {
                if (item.content == itm.content) {
                    this.$message.warning('规格值不能重复')
                    let item = this.specList[val].value[val2];
                    item.isDel = true;
                    this.handleSpecValues(this.skuList.children, item);
                    this.specList[val].value.splice(val2, 1);
                }
            })
        },
        // 规格值改变-输入事件
        specItemValChange(item, itm) {
            console.log(item, itm)
            let num = 0
            this.specList.forEach((ite, inx) => {
                ite.value.forEach((item2, index2) => {
                    console.log(item2);
                    if (itm.content == item2.content) {
                        // alert(1)
                        num + 1
                        if (num > 2) {
                            this.specList.pop()
                            // alert(1)
                        }
                    }
                })
            })
            if (!this.skuOrdering) {
                this.handleSpecValues(this.skuList.children, itm)
                console.log(this.skuList)

            }
            console.log(this.skuList)
        },
        pinpai() {
            let obj = {
                pageNum: 1,
                pageSize: 1000
            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                console.log(res)
                this.ppList = res.data.szProductsBrandList
            })
        },
        spflFn() {
            this.$http.orders.ordersClass().then(res => {
                console.log(res)
                this.flList = res.data

            })
        },
        handleSpecValues(arr, itm, arr2) {
            let isEdit = false;
            arr.forEach((item, index) => {
                if (arr2) {
                    let obj = {
                        id: '0',
                        spec_value_name: item.spec_value_name,
                        idx1: item.idx1,
                        idx2: item.idx2,
                        spec_title_id: item.spec_title_id
                    }
                    if (!item.children || item.children == '-10') {
                        obj.price = 0;
                        obj.price_underline = 0;
                        obj.stock = 0;
                    } else {
                        obj.children = [];
                    }
                    arr2.push(obj);
                    if (item.children && item.children != '-10') {
                        this.handleSpecValues(item.children, itm, arr[arr.length - 1].children)
                    }
                } else {

                    if (((item.idx1 || item.idx1 === 0) && item.idx1 == itm.idx1) || (itm.spec_title_id && (item.spec_title_id == itm.spec_title_id))) {
                        //一级相等
                        if (((item.idx2 || item.idx2 === 0) && item.idx2 == itm.idx2) || (item.spec_value_id && item.spec_value_id == itm.id)) {
                            console.log("修改规格值", itm, item)
                            //修改规格值
                            if (itm.content == '' || itm.isDel) {
                                //填写的规格值内容为空或删除规格值操作时
                                arr.splice(index, 1);
                                console.log('填写的规格值内容为空或删除规格值操作', arr)
                            } else {
                                item.spec_value_name = itm.content;
                            }
                            isEdit = true;
                        } else if (index == arr.length - 1 && !isEdit) {
                            if (itm.isDel) {
                                console.log('删除规格值', arr)
                                arr.splice(itm.idx2, 1); return false;
                            }
                            //追加规格值
                            let obj = {
                                id: '0',
                                spec_value_name: itm.content,
                                idx1: itm.idx1,
                                idx2: itm.idx2,
                                spec_title_id: itm.spec_title_id
                            };
                            if (!item.children || item.children == '-10') {
                                obj.price = 0;
                                obj.price_underline = 0;
                                obj.stock = 0;
                            } else {
                                obj.children = [];
                            }
                            arr.push(obj);
                            if (item.children && item.children != '-10') {
                                this.handleSpecValues(item.children, itm, arr[arr.length - 1].children)
                            }
                        }
                    } else {
                        console.log("一级不相等")
                        // 一级不相等
                        if (item.children && item.children != '-10') {
                            this.handleSpecValues(item.children, itm)
                        }
                    }
                }
            })
        },
        flChange(val) {
            console.log(val.toString());
            this.form.goodsType = val
            this.$set(this.form, 'classA', val)
        },
        handleSpec2(idx, item, arr) {
            if (idx < arr.length) {
                item.children = JSON.parse(JSON.stringify(arr[idx]));
                ++idx;
                item.children.forEach((itm, idx2) => {
                    let lowerTitles = arr[arr.length - 1].map(itm2 => itm2.spec_value_name);
                    if (lowerTitles.includes(itm.spec_value_name)) {
                        itm.price = 0;
                        itm.price_underline = 0;
                        itm.stock = 0;
                    }
                    this.handleSpec2(idx, itm, arr)
                })
            } else {
                item.price = 0;
                item.price_underline = 0;
                item.stock = 0;
            }
            return item;
        },

        // tabs

        showText(val) {
            this.flag = val
        },

        //实现图片拖拽排序

        initDragSort() {
            // 支持拖拽排序
            console.log(this.$refs.upload);
            const el = this.$refs.upload.$el.querySelectorAll('.el-upload-list')[0];
            Sortable.create(el, {
                onEnd: ({ oldIndex, newIndex }) => {
                    // 交换位置

                    const arr = this.premisesFileList;
                    console.log(this.premisesFileList);
                    const page = arr[oldIndex];
                    arr.splice(oldIndex, 1);
                    arr.splice(newIndex, 0, page);
                    this.arrS = []
                    arr.forEach(item => {
                        this.arrS.push(item.url)
                    })
                }
            });
        },
        videoUploadSuccess(file) {
            console.log(file);
            this.videos = file.url;
            this.videosImg = file.thumb
        },

        //图片上传成功

        handleImgSuccess(file, type) {
            switch (type) {
                case "premises":
                    this.premisesFileList.push({ url: file.url, name: file.title });
                    console.log(this.premisesFileList);
                    this.arrS = []
                    this.premisesFileList.forEach(item => {
                        console.log('this.arrS===>', this.arrS);
                        this.arrS.push(item.url)
                    })
                    console.log(this.arrS);

                    const formName = ['form0', 'form1', 'form2', 'form3']
                    const validates = (item) => {
                        return new Promise((resolve, reject) => {
                            console.log(this.$refs[item]);
                            if (!this.$refs[item]) {
                                resolve()
                                return false
                            }
                            this.$refs[item].validate((valid) => {
                                if (valid) {
                                    resolve()
                                } else {
                                    reject(new Error('验证不对'))
                                }
                            })
                        })
                    }
                    Promise.all(formName.map(item => validates(item))).then(() => {
                        console.log('成功')
                        let obj = {
                            brandId: this.form.brand,//品牌id	
                            enterpriseId: this.form.supplier,//供应商id		
                            mainSpuImageUrl: this.arrS[0],//商品主图		
                            // mainSpuVideoUrl: 'http.ceshi.mp4',//商品视频	
                            mainSpuVideoUrl: this.videos,//商品视频	
                            markingPrice: this.hjx,//划线价		
                            modeOfDay: this.ghzq,//供货周期	
                            modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                            oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                            ordinarySpuImageUrl: this.arrS + '',//商品普通图	
                            parmJson: JSON.stringify(this.tableData),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                            productDesc: this.editValue,//商品描述PC		
                            //  productDescApp: "<p>111</p>",//商品描述App		
                            productsName: this.form.goodsName,//spuName
                            productsPrice: this.jiage,//商品价格	
                            salePoint: this.form.goodsPoints,//卖点
                            specJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                            specTitleValueJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                            status: 20,//状态（10:上架;20:下架)	
                            threeClassId: this.form.goodsType[2].toString(),//生资三级分类	
                            twoClassId: this.form.goodsType[1].toString(),//生资二级分类	
                        }
                    }).catch(() => {
                        console.log('失败')
                    })
                    break;
                case "specification":
                    this.SpecificationImage.push({ url: file.url, name: file.title });
                    break;
                case "videoOne":
                    this.fileVideoList.push({ url: file.url, name: file.title });
                    break;
                // case "specification":
                //     this.orderListsImg.push({ url: file.url, name: file.title });
                //     break;
            }

        },
        addButn(val) {

            this.tableData.push({ idss: this.uuid(), parmKey: "", parmValue: "" })
            this.tableData.forEach((item, index) => {
                return item + ''
            })
            console.log(this.tableData)
        },
        jiageChange(val) {
            // this.$set(this.jiage, 'jiage', val)
            this.jiage = val
        },
        shanchu(val) {
            this.tableData.splice(this.tableData.findIndex(item => item.idss === val.idss), 1)
        },
        // 删除图片

        handleRemoveImg(file, type) {
            switch (type) {
                case "premises":
                    this.premisesFileList.forEach((item, index) => {
                        if (item.url == file.url) {
                            this.premisesFileList.splice(index, 1)
                        }
                    })
                    this.arrS = []
                    this.premisesFileList.forEach(item => {
                        this.arrS.push(item.url)
                    })
                    console.log(this.arrS)
                    // this.premisesFileList.push({ url: file.url, name: file.title });
                    // this.premisesFileList.forEach(item => {
                    //     this.arrS.push(item.url)
                    // })
                    break;
                case "specification":
                    // this.SpecificationImage = this.SpecificationImage.map(
                    //     (item) => item.url != file.url
                    // );
                    this.SpecificationImage.forEach((item, index) => {
                        if (item.url == file.url) {
                            this.SpecificationImage.splice(index, 1)
                        }
                    })
                    console.log(this.SpecificationImage)
                    break;
            }
        },

        //预览图片

        handlePreviewImg(file) {
            this.previewImgUrl = file.response ? file.response.url : file.url;
            this.previeImgVisible = true;
        },

        //自定义上传

        handleCustomUpload(content) {
            uploadImg(content)
                .then((res) => {
                    content.onSuccess(res.data);
                })
                .catch((err) => {
                    content.onError(err);
                });
        },
        formYlan() {
            console.log(this.SpecificationImage)
            var imgList = [];
            if (this.SpecificationImage.length > 0) {
                var item = this.SpecificationImage;
                for (var i = 0; i < item.length; i++) {
                    imgList.push(item[i].url)
                }
            }
            console.log(imgList);
            var specJson = [];
            var specTitleValueJson = [];
            var item = this.skuList.children;

            var arr = [];
            var arr2 = [];
            var arr3 = [];
            for (var i = 0; i < item.length; i++) { //循环第一级

                var item2 = item[i].children;
                //第一个数组
                arr.push({
                    valueName: item[i].spec_value_name,
                    valueSort: i,
                    titleImageUrl: imgList.length > 0 ? imgList[i] : ''
                })
                if (item2) {
                    for (var j = 0; j < item2.length; j++) { //循环二级				
                        var item3 = item2[j].children;
                        //第二个数组
                        if (i == 0) {
                            arr2.push({
                                valueName: item2[j].spec_value_name,
                                valueSort: j,
                            });
                        }
                        if (item3) {
                            for (var m = 0; m < item3.length; m++) { //循环三级	
                                //第三个数组
                                console.log(item3[m])
                                if (j == 0 && i == 0) {
                                    arr3.push({
                                        valueName: item3[m].spec_value_name,
                                        valueSort: m,
                                    })
                                }
                                specJson.push({

                                    valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name + ',' + item3[m].spec_value_name,
                                    price: item3[m].price,
                                    valueSort: i
                                })
                            }
                        }
                        if (!item3) {
                            specJson.push({
                                valueName: item[i].spec_value_name + ',' + item2[j].spec_value_name,
                                price: item2[j].price,
                                valueSort: i

                            })
                        }

                    }

                }
                if (!item2) {
                    specJson.push({
                        valueName: item[i].spec_value_name,
                        price: item[i].price,
                        valueSort: i

                    })
                }
            }
            for (let i = 0; i < this.specListHead.length; i++) {
                if (i == 0) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr,
                        titleImageUrl: ''
                    })
                } else if (i == 1) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr2
                    })
                } else if (i == 2) {
                    specTitleValueJson.push({
                        title: this.specListHead[i].title,
                        titleSort: i,
                        value: arr3
                    })
                }
            }

            console.log("specTitleValueJson", specTitleValueJson)
            console.log("specJson", JSON.stringify(specJson))
            console.log(this.videos)
            const formName = ['form0', 'form1', 'form2', 'form3']
            const validates = (item) => {
                return new Promise((resolve, reject) => {
                    console.log(this.$refs[item]);
                    if (!this.$refs[item]) {
                        resolve()
                        return false
                    }
                    this.$refs[item].validate((valid) => {
                        if (valid) {
                            resolve()
                        } else {
                            reject(new Error('验证不对'))
                        }
                    })
                })
            }
            console.log(this.arrS);
            alert(this.ghfs)

            let obj = {
                brandId: this.form.brand,//品牌id	
                enterpriseId: this.form.supplier,//供应商id		
                mainSpuImageUrl: this.arrS[0],//商品主图		
                mainSpuVideoUrl: this.videos,//商品视频	
                // markingPrice: this.hjx,//划线价		
                modeOfDay: this.ghzq || '',//供货周期	
                modeOfSupply: this.ghfs,//供货方式（10:现货;20:非现货)	
                oneClassId: this.form.goodsType[0].toString(),//生资一级分类	
                ordinarySpuImageUrl: this.arrS + '',//商品普通图	
                parmJson: JSON.stringify(this.tableData),//商品参数JSON 示例：[{\n "parmKey": "保质期",\n "parmValue": "180天"\n}]
                productDesc: this.editValue,//商品描述PC		
                productsName: this.form.goodsName,//spuName
                productsPrice: this.jiage,//商品价格	
                salePoint: this.form.goodsPoints,//卖点
                specTitleValueJson: JSON.stringify(specJson), //'[{\n "title": "颜色",//规格名称\n "titleSort": "1",//规格名称排序\n "titleImageUrl": "1",//规格图片\n "value": [{\n "valueName": "规格值名称",\n "valueImageUrl": "图片url",\n "valueSort": 1 规格值排序\n }]\n}]'
                specJson: JSON.stringify(specTitleValueJson),//'[{\n "valueName": "净含量,无毒",//规格名称,号分隔\n "price": "1.98",//价格\n}]',
                threeClassId: this.form.goodsType.length > 2 ? this.form.goodsType[2].toString() : '',//生资三级分类	
                twoClassId: this.form.goodsType.length > 1 ? this.form.goodsType[1].toString() : '',//生资二级分类	
                mainSpuVideoCoverUrl: this.videosImg
            }
            window.localStorage.setItem('obj', JSON.stringify(obj))
            this.$http.supplierApi.getSupplierDetail({ id: this.form.supplier }).then((res) => {
                console.log(res.data)
                let supper = ''
                let data = res.data
                let logo = {}
                data.szProductsMediaList.forEach((item, index) => {
                    if (item.types == 30) {
                        logo = item.imgUrl
                    }

                })
                supper = {
                    addr: data.addr,
                    enterpriseName: data.enterpriseName,
                    registAddr: data.registAddr,
                    scopes: data.scopes,
                    logo: logo
                }
                console.log(supper)
                window.localStorage.setItem('supper', JSON.stringify(supper))

            })

            let routedata = this.$router.resolve({
                path: "./Preview",
            });
            window.open(routedata.href, '_blank');
        },
        lists() {
            let obj = {
                pageNum: 1,
                pageSize: 10,
            }

            this.$http.orders.commodityList(obj).then(res => {
                this.listsData = res.data.szProductsSpuList
                console.log(this.listsData[0].id);
            })
            setTimeout(() => {
                let routedata = this.$router.resolve({
                    path: "./Preview",
                    query: {
                        id: this.listsData[0].id
                    }
                });
                window.open(routedata.href, '_blank');
            }, 100)

        }
    },
};
